import React, {useEffect, useState, useRef} from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import HotspotsMoto from "./Hotspots/HotspotsMoto";
import './home.scss';
import Google from "../media/google.png"
import MotorcycleCard from "../shop/motorcycle-item";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaStar } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import { FaClock } from "react-icons/fa";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const HomePage = ({host}) => {
  const [motocycles, setMotocycles] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);


    useEffect(() => {
    fetch(`${host}/api/shop/motorcycles/?fields=id,title,price,main_image,mileage,production_year,engine_capacity,license_category`)
        .then((res) => res.json())
        .then((data) => setMotocycles(data))
        .catch((err) => console.error("Error loading motorcycles:", err));
    }, [host]);

  return (
    <main className="home min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
        <>
            <Helmet>
                <title>Serwis motocykli Mrowino – PRO MOTO Serwis</title>
                <meta
                    name="description"
                    content="Profesjonalny serwis motocykli w Mrowinie. Naprawy, przeglądy techniczne, transport i zimowanie."
                />
                <link rel="canonical" href="https://promotoserwis.pl/" />
            </Helmet>
        </>
        <section className="home-hero">
            <motion.div
                className="hero-content"
                initial={{ opacity: 0, y: 60 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    Serwis i sprzedaż motocykli
                </motion.h1>

                <p className="hero-subtitle">
                    Motocykle to nasza codzienność i pasja. Od wielu lat dbamy o to, 
                    żeby motocykliści mogli jeździć bezpiecznie i kupować pewne maszyny.
                </p>

                <div className="google-rating">
                    <img
                        src={Google}
                        alt="Google"
                        className="google-logo"
                        width="129px"
                    
                    />

                    <div className="star-wrapper">
                        <div className="stars-outer">
                            <div className="stars-inner" style={{ width: `${(4.8 / 5) * 100}%` }}></div>
                        </div>
                        <span className="rating-value">4.8</span>
                        <span className="rating-opinions"> · 140+ opinii</span>
                    </div>
                </div>
                    <button className="hero-content-btn"><Link  to="/motocykle" >AKTUALNE OFERTY</Link></button>
                    <button className="hero-content-btn_owner"><Link  to="/o-firmie" >Dowiedz się więcej</Link></button>
                <div>

                </div>
            </motion.div>
            <HotspotsMoto />
        </section>
        <section className="home-ofer">
            
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.9 }}
                viewport={{ once: true, amount: 0.4 }}
            >
                <h3>Serwis motocykli, quadów i skuterów</h3>
                <ul>
                    <li>Kompleksowe naprawy – silnik, układ napędowy, zawieszenie, hamulce</li>
                    <li>Przeglądy techniczne – przygotowanie do rejestracji i sezonu</li>
                    <li>Diagnostyka komputerowa – szybkie wykrywanie usterek</li>
                </ul>
                <button><Link  to="/serwis" >Poznaj pełną ofertę</Link></button>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, x: -140 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.4}}
            >
                <h3>Sprzedaż i skup motocykli używanych</h3>
                <ul>
                    <li>Sprawdzone motocykle używane – każdy egzemplarz przechodzi dokładny przegląd</li>
                    <li>Skup motocykli – gotówka od ręki lub rozliczenie przy zakupie</li>
                </ul>
                <button><Link  to="/motocykle" >Poznaj pełną ofertę</Link></button>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, x: -180 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true, amount: 0.4}}
            >
                <h3>Usługi dodatkowe</h3>
                <ul>
                    <li>Transport motocykli – bezpiecznie Poznań i województwo wielkopolskie</li>
                    <li>Zimowanie motocykli – monitorowana przechowalnia</li>
                    <li>Doradztwo przy zakupie – pomożemy wybrać motocykl skrojony pod Twoje potrzeby</li>
                </ul>
                <button><Link to="/pozostale_uslugi" >Poznaj pełną ofertę</Link></button>
            </motion.div>
        </section>
      <section  className="home-swiper">  
        <motion.div
            initial={{ opacity: 0, x: -180 }}
            className="home-swiper_info"
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true, amount: 0.4}}
        >
            <h3>Sprzedaż motocykli używanych</h3>
            <h5>
                Szukasz sprawdzonego motocykla – takiego, który od razu jest gotów do jazdy?
            </h5>
            <p>W PRO MOTO oferujemy wyłącznie maszyny po pełnym przeglądzie serwisowym, dzięki czemu masz pewność stanu technicznego i legalnego pochodzenia.</p>
        </motion.div>
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}   
            navigation={{ nextEl: ".swiper-next", prevEl: ".swiper-prev" }}  
            pagination={{ clickable: true }}
            breakpoints={{
                1300: { slidesPerView: 2 }
            }}
            autoplay={{
            delay: 5000, 
            disableOnInteraction: false,
            }}
            spaceBetween={10}
            onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                }}
            className="moto-slider"
        >
            {motocycles.map((moto) => (
            <SwiperSlide key={moto.id}>
                <MotorcycleCard moto={moto} />
            </SwiperSlide>
            ))}
        </Swiper>
      </section>
      <section className="home-why_us"> 
        <motion.div
            className="home-why_us-title"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <h2>
                Dlaczego PRO MOTO?
            </h2>
            <p>Motocykliści dla motocyklistów - rozumiemy Twoją pasję</p>
        </motion.div>
        <div className="home-why_us-items">
             
            <motion.div
                className="home-why_us-items-item"
                initial={{ opacity: 0, y: 160 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="home-why_us-items-item_icon"><FaStar /></div>
                <div>
                    <h4>od wielu lat naprawiamy motocykle</h4>
                    <p>wiemy, co robimy</p>
                </div>
            </motion.div>
            <motion.div
                className="home-why_us-items-item"
                initial={{ opacity: 0, y: 140 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="home-why_us-items-item_icon"><FaGoogle /></div>
                <div>
                    <h4>140+ opinii Google</h4>
                    <p>mówimy językiem zaufania</p>
                </div>
            </motion.div>
            <motion.div
                className="home-why_us-items-item"
                initial={{ opacity: 0, y: 120 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="home-why_us-items-item_icon"><FaFileAlt /></div>
                <div>
                    <h4>Pełna przejrzystość</h4>
                    <p>jasna wycena przed rozpoczęciem prac</p>
                </div>
            </motion.div>
            <motion.div
                className="home-why_us-items-item"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="home-why_us-items-item_icon"><FaClock /></div>
                <div>
                    <h4>Terminy na czas</h4>
                    <p>szanujemy Twój sezon motocyklowy</p>
                </div>
            </motion.div>
        </div>
      </section>
       <section className="home-footer_contact">
            <div className="home-footer_contact-container">
                <div className="home-footer_contact-container_top-card"> 
                    <h2>Mrowino i okolice</h2>
                    <h4>PRO MOTO - Twój lokalny partner</h4>
                    <p>
                        Choć obsługujemy klientów z całej Polski, 
                        to Mrowino jest naszym domem. Wpadnij na kawę, poznaj 
                        ekipę i zobacz na żywo warsztat, w którym o motocykle dba się tak, 
                        jak o własne.</p>
                </div>
                <div className="home-footer_contact-container_info">
                    <h4>Działamy od poniedziałku do piątku w godzinach 08:00 - 16:30
                         Dworcowa 11, 62-090 Mrowino</h4>
                    <h2>Zapraszamy!</h2>
                </div>

            </div>
       </section>
    </main>
  );
};

export default HomePage;
